import MaskAndValid from "utils/maskAndValid";
import { Card, CardContent, Chip } from "@material-ui/core";
import { columnPriceField, columnTextField } from "utils/tables-utils";
import TableComponent from "components/_refactor/table/table";

export default function TableRelatorioPerformance({ dataTable, periodo }) {
  const columnModel = [
    columnTextField({
      dataField: "Loja",
      text: "Loja",
    }),
    columnTextField({
      dataField: "Vendedor",
      text: "Vendedor",
    }),
    columnTextField({
      dataField: "Periodo",
      text: "Período",
      align: "center",
    }),
    columnPriceField({
      dataField: "MetaIndividual",
      text: "Meta",
    }),
    columnPriceField({
      dataField: "Realizado",
      text: "Realizado",
    }),
    columnTextField({
      dataField: "Atingimento",
      text: "Atingimento (%)",
      align: "center",
      formatter: (cell) => {
        return `${cell}%`;
      },
    }),
    columnTextField({
      dataField: "FaixaPremiacao",
      text: "Faixa de Premiação",
    }),
    columnTextField({
      dataField: "Bonificacao",
      text: "Bonificação",
      align: "center",
      formatter: (cell) => {
        return cell === "Não Atingiu"
          ? "R$ 0,00"
          : `R$ ${MaskAndValid.maskPrice(cell)}`;
      },
    }),
    columnTextField({
      dataField: "Status",
      text: "Status",
      align: "center",
      formatter: (_, row) => {
        const atingiu = row.Bonificacao > 0;
        return (
          <Chip
            label={atingiu ? "Atingido" : "Não atingido"}
            size="small"
            style={{
              width: "150px",
              padding: "1rem 0.5rem",
              backgroundColor: atingiu
                ? "rgba(0, 128, 0, 0.1)"
                : "rgba(244, 67, 54, 0.1)",
              border: atingiu
                ? "1px solid rgba(0, 128, 0, 0.5)"
                : "1px solid rgba(244, 67, 54, 0.5)",
            }}
          />
        );
      },
      csvFormatter: (_, row) => {
        const atingiu = row.Atingimento >= 100;
        return atingiu ? "Atingido" : "Não atingido";
      },
    }),
  ];
  return (
    <Card>
      <CardContent>
        <TableComponent
          keyField="Vendedor"
          dataTable={dataTable}
          columnModel={columnModel}
          csvFileName="RelatorioPerformance.csv"
          showPrint
          searched={Boolean(dataTable)}
          headerTitle={`Relatório ${periodo}`}
          notFoundTitle="Sua pesquisa não encontrou nenhum resultado correspondente."
        />
      </CardContent>
    </Card>
  );
}
